import React, { Component } from "react";
import { Form, Button, Divider } from "semantic-ui-react";

import Input from "../Shared/Input";
import { defaultPhoneNumber } from "../lib/defaultObjects";
import _ from "lodash";

class PhoneNumberForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...defaultPhoneNumber(props.phoneNumber)
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(this.state, prevState)) {
      this.props.onUpdate(this.state);
    }
  }
  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  };
  handleToggle = (e, { name }) => {
    this.setState(state => ({
      [name]: !state[name]
    }));
  };
  handleSave = () => {
    this.props.handleSave(this.state);
  };
  handleDelete = () => {
    this.props.handleDelete(this.state);
  };
  render() {
    let { phoneNumber, isPrimary, label } = this.state;
    let { hideActionButtons } = this.props;

    return (
      <Form>
        <Button
          type="button"
          toggle
          content="Primary Phone Number"
          name="isPrimary"
          active={isPrimary}
          onClick={this.handleToggle}
        />
        <Divider hidden />
        <Form.Group widths={2}>
          <Input
            label="Label"
            isEditing
            value={label}
            onChange={this.handleChange}
            name="label"
          />
          <Input
            label="Phone Number"
            value={phoneNumber}
            onChange={this.handleChange}
            name="phoneNumber"
            isEditing
          />
        </Form.Group>
        {!hideActionButtons && (
          <>
            <Button color="green" content="Save" onClick={this.handleSave} />
            <Button color="red" content="Delete" onClick={this.handleDelete} />
          </>
        )}
      </Form>
    );
  }
}

PhoneNumberForm.defaultProps = {
  handleSave: () => {},
  handleDelete: () => {},
  onUpdate: () => {},
  hideActionButtons: false
};

export default PhoneNumberForm;
